export default "__VITE_PUBLIC_ASSET__9ac0343d__"